import { ElementApi, PathApi, type SlateEditor, TextApi } from '@udecode/plate';

import { BaseSuggestionPlugin } from '../BaseSuggestionPlugin';
import type { TSuggestionText } from '../types';
import { getInlineSuggestionData } from '../utils';

export const acceptAllSuggestions = (
    editor: SlateEditor
) => {
    editor.tf.withoutNormalizing(() => {
        const mergeNodes = [
            ...editor.api.nodes({
                at: [],
                match: (n) => {
                    if (!ElementApi.isElement(n)) return false;

                    if (
                        editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                    ) {
                        return (
                            n.suggestion.type === 'remove' &&
                            n.suggestion.isLineBreak
                        );
                    }

                    return false;
                },
            }),
        ];

        mergeNodes.reverse().forEach(([, path]) => {
            editor.tf.mergeNodes({ at: PathApi.next(path) });
        });

        editor.tf.unsetNodes([BaseSuggestionPlugin.key], {
            at: [],
            mode: 'all',
            match: (n) => {
                if (TextApi.isText(n)) {
                    const suggestionDataList = editor
                        .getApi(BaseSuggestionPlugin)
                        .suggestion.dataList(n as TSuggestionText);

                    const includeUpdate = suggestionDataList.some(
                        (data) => data.type === 'update'
                    );

                    if (includeUpdate) {
                        return true;
                    } else {
                        const suggestionData = getInlineSuggestionData(n);

                        if (suggestionData)
                            return (
                                suggestionData.type === 'insert'
                            );
                    }

                    return false;
                }
                if (
                    ElementApi.isElement(n) &&
          editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                ) {
                    const suggestionData = n.suggestion;

                    if (suggestionData) {
                        const isLineBreak = suggestionData.isLineBreak;

                        if (isLineBreak) return true;

                        return (
                            suggestionData.type === 'insert'
                        );
                    }
                }

                return false;
            },
        });

        editor.tf.removeNodes({
            at: [],
            mode: 'all',
            match: (n) => {
                if (TextApi.isText(n)) {
                    const suggestionData = getInlineSuggestionData(n);

                    if (suggestionData) {
                        return (
                            suggestionData.type === 'remove'
                        );
                    }

                    return false;
                }

                if (
                    ElementApi.isElement(n) &&
                    editor.getApi(BaseSuggestionPlugin).suggestion.isBlockSuggestion(n)
                ) {
                    const suggestionData = n.suggestion;

                    if (suggestionData) {
                        const isLineBreak = suggestionData.isLineBreak;

                        return (
                            suggestionData.type === 'remove' &&
                            !isLineBreak
                        );
                    }
                }

                return false;
            },
        });
    });
};
